let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lfV4b")).then(() => parcelRequire('c88aq'));